import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import ContextMenu from "../../../components/contextMenu";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import {Divider} from "@material-ui/core";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../../utils/constants/Constants";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const IntraInstitutionalReportView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="Reportes \ Préstamos intrainstitucionales"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getDataReport}
                                             buttonName={"Parámetros"}
                                             withButtons={"false"}
                                             disabledSearchButton = {props.disabledSearchButton}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Inicial" isBold={true}/>
                                    <Calendar name="startDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.startDate}
                                              onChange={props.onChangeFilters}
                                              maxDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Final" isBold={true}/>
                                    <Calendar name="finalDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.finalDate}
                                              onChange={props.onChangeFilters}
                                              minDate={props.filters.startDate}
                                              maxDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6"/>
                                <div className="p-col-12 p-md-6 p-col-6"/>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default IntraInstitutionalReportView;